<template>
    <div :class="$style.block">
        <div v-show="!setting">
            {{text}}<i class="el-icon-edit-outline" @click="setting = true"></i>
        </div>
        <div v-show="setting">
            <el-select v-model="select" filterable :size="size">
                <el-option
                        v-for="item of list"
                        :key="item.label"
                        :label="item.label"
                        :value="item"/>
            </el-select>
            <i :class="[$style.icon,'el-icon-circle-check']" @click="updateFunc"></i>
            <i :class="[$style.icon,'el-icon-circle-close']" @click="closeFunc"></i>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            text: [String, Number],
            list: {
                type: Array,
                default: () => [{
                    label: 1,
                    value: 1
                }]
            },
            size: {
                type: String,
                default: 'small',
            }
        },
        data() {
            return {
                setting: false,
                select: ''
            }
        },
        methods: {
            updateFunc() {
                this.$emit('my-submit', {
                    label: this.select.label,
                    value: this.select.value,
                    cb: () => {
                        this.setting = false
                    }
                });
            },
            closeFunc() {
                this.setting = false;
            }
        }
    }
</script>
<style lang="scss" module>
    .block {
        display: inline-block;
        :global(.el-icon-edit-outline){
            color: $theme-color;
            cursor: pointer;
        }

        :global(.el-input) {
            width: 150px;
        }
        :global(.el-input__inner) {
            padding: 0 10px;
        }
        .icon {
            margin-left: 3px;
            font-size: 20px;
            vertical-align: middle;
            cursor: pointer;
            &:hover {
                color: $theme-color;
                transform: translateY(-1px);
            }
        }
    }

</style>